import React from 'react';

function UserRoundedIcon({
  size = 80,
  variant = 'primary',
  bgColor,
  glyphFill,
  strokeColor,
  strokeWidth = 6,
  className,
  title = 'Usuário',
  style,
  ...props
}) {
  const palette = {
    primary: { bg: '#5062F0', glyph: '#B8BFF5', stroke: '#202B85' },
    chinaLabel: { bg: '#000000', glyph: '#E5AD5C', stroke: '#E5AD5C' },
    muted:   { bg: '#D0D3E2', glyph: '#9296AC', stroke: '#9296AC' }
  };

  const colors = palette[variant] || palette.primary;
  const _bg     = bgColor     || colors.bg;
  const _glyph  = glyphFill   || colors.glyph;
  const _stroke = strokeColor || colors.stroke;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : 'presentation'}
      {...props}
    >
      {title ? <title>{title}</title> : null}

      <circle cx="40" cy="40" r="40" fill={_bg} />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 20C32.8788 20 27 25.6135 27 32.6667C27 39.7198 32.8788 45.3333 40 45.3333C47.1212 45.3333 53 39.7198 53 32.6667C53 25.6135 47.1212 20 40 20ZM29 52C25.5717 52 22.2719 53.32 19.8295 55.6884C17.3851 58.0588 16 61.2871 16 64.6667C16 65.3004 16.3003 65.8966 16.8095 66.2738L34 78.3221C34.8876 78.9795 36.9496 80.078 37.6071 79.1905C38.096 78.5305 38.1182 77.6688 37.7326 77H46C45.9998 77.4699 46.1643 77.9418 46.4993 78.3221C47.2294 79.1509 48.4932 79.2309 49.3221 78.5007L63.3221 66.1674C63.7531 65.7877 64 65.241 64 64.6667C64 61.2871 62.6149 58.0588 60.1705 55.6884C57.7281 53.32 54.4283 52 51 52H29Z"
        fill={_glyph}
      />

      <circle cx="40" cy="40" r="37" stroke={_stroke} strokeWidth={strokeWidth} fill="none" />
    </svg>
  );
}

export default UserRoundedIcon;
